import { StandardEvents } from '@shopify/events';

/* Hurtigkjøp: trykk på en størrelse legger skjorta i kurven (Sloth-stil).
   Selve kjøpet går gjennom temaets egen knapp, så kurven oppdateres som vanlig.
   Størrelsesknappen vet allerede varianten, så vi hopper over temaets ekstra
   henting av varianten. Bare mens et fargebytte lastes bruker vi temaets vanlige,
   tregere vei, for da kan varianten på knappen være utdatert. */
let colorChanges = 0;

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element) || !event.target.closest('dialog.quick-add-modal')) return;
  colorChanges += 1;
  const done = () => { colorChanges -= 1; };
  if (event.promise) event.promise.then(done, done);
  else done();
});

document.addEventListener(
  'change',
  (event) => {
    if (!event.isTrusted || !(event.target instanceof HTMLInputElement)) return;
    const dialog = event.target.closest('dialog.quick-add-modal');
    if (!dialog || !event.target.closest('[data-bmp-size-fieldset]')) return;

    // Ett kjøp per åpning: et nytt valg mens kjøpet pågår skal ikke legge i en størrelse til.
    if (dialog.hasAttribute('data-wwsw-adding')) {
      event.stopImmediatePropagation();
      return;
    }

    const form = dialog.querySelector('product-form-component');
    const button = dialog.querySelector('[ref="addToCartButton"]');
    if (!form || !button || button.disabled) return;

    const variantInput = form.querySelector('input[name="id"]');
    const variantId = event.target.dataset.variantId;
    if (colorChanges === 0 && variantId && variantInput && event.target.dataset.optionAvailable !== 'false') {
      event.stopImmediatePropagation();
      variantInput.value = variantId;
      variantInput.disabled = false;
      form.setAttribute('data-bmp-size-satisfied', 'true');
    }

    dialog.setAttribute('data-wwsw-adding', '');
    const reset = () => dialog.removeAttribute('data-wwsw-adding');
    dialog.addEventListener('close', reset, { once: true });
    document.addEventListener(StandardEvents.cartError, reset, { once: true });
    setTimeout(reset, 5000);

    // Etter størrelseskravets egen change-lytter, så porten er åpen når vi klikker.
    setTimeout(() => button.click(), 0);
  },
  { capture: true }
);
